class FeaturedTabs extends HTMLElement {
  connectedCallback() {
    this.initTabs();
  }

  initTabs() {
    const buttonContainer = this.querySelector(".featured-tab-buttons");
    const blocks = this.querySelectorAll(".shopify-block");

    if (!buttonContainer || !blocks.length) return;

    // clear any existing buttons
    buttonContainer.innerHTML = "";

    blocks.forEach((block, index) => {
      const originalButton = block.querySelector(".featured-tab-button");
      const content = block.querySelector(".featured-tab-content");

      if (!originalButton || !content) return;

      // clone the button into header
      const clonedButton = originalButton.cloneNode(true);
      clonedButton.classList.remove("active"); // reset state

      // wire click event
      clonedButton.addEventListener("click", () => {
        this.activateTab(index);
      });

      buttonContainer.appendChild(clonedButton);
    });

    // activate the first tab by default
    this.activateTab(0);
  }

  activateTab(activeIndex) {
    const buttonContainer = this.querySelector(".featured-tab-buttons");
    const buttons = buttonContainer.querySelectorAll(".featured-tab-button");
    const contents = this.querySelectorAll(".featured-tab-content");

    // remove all active states
    buttons.forEach(btn => btn.classList.remove("active"));
    contents.forEach(content => content.classList.remove("active"));

    // add active state to selected
    if (buttons[activeIndex]) buttons[activeIndex].classList.add("active");
    if (contents[activeIndex]) contents[activeIndex].classList.add("active");
  }
}

customElements.define("featured-tabs", FeaturedTabs);
